module.exports = __webpack_public_path__ + "img/Mask Group 2922@2x.28a1c33e.png";